import React from 'react'
import { WTNScaleData } from '@clubspark-react/clubspark-itf-shared-components'
import { getGraphQlApiEndpoint } from 'constants/api'
import PsqWidget from 'components/psq/PsqWidget'

interface Props {
  profileLoading: boolean
  tennisID: string | undefined
  wtnSingles: string | undefined
  wtnDoubles: string | undefined
  eligibleForPsq: boolean
}

const WTNDefinition: React.FC<Props> = ({
  profileLoading,
  wtnSingles,
  wtnDoubles,
  tennisID,
  eligibleForPsq,
}) => {
  const shouldShowPsqWidget = !Boolean(wtnSingles) && !Boolean(wtnDoubles) && eligibleForPsq

  return (
    <>
      {profileLoading ? null : shouldShowPsqWidget ? (
        <PsqWidget />
      ) : (
        <WTNScaleData
          mode={''}
          border={false}
          animDuration={4500}
          labelsDesktop
          labelsMobile
          mobileBreakPoint={767.98}
          width={340}
          tennisID={tennisID || ''}
          endpointURL={getGraphQlApiEndpoint()}
          infoModalZIndex={10000}
        />
      )}
    </>
  )
}

export default WTNDefinition
